import { Stack, useTheme } from "@mui/material";
import type { FC } from "react";
import type { SettingsMenuItemType } from "web_myplann/More/Types/SettingsMenuItemType";
import { ListRow } from "web_myplann/Shared/Components/ListRow";

type Props = {
	items: SettingsMenuItemType[];
};

export const SettingsMenuSection: FC<Props> = ({ items }) => {
	const theme = useTheme();

	return (
		<Stack bgcolor={theme.palette.background.paper}>
			{items.map(
				({ id, icon: Icon, label, iconBg, iconColor, onClick }, index) => (
					<ListRow
						key={id}
						title={label}
						icon={<Icon size={theme.iconSize.md} color={iconColor} />}
						iconBg={iconBg}
						showChevron
						isLast={index === items.length - 1}
						onClick={onClick}
					/>
				),
			)}
		</Stack>
	);
};
